import React from "react";
import { SelectFilter } from "../search/SelectFilter";
import { LeftSearchMenuPiece } from "../search/LeftSearchMenuPiece";
import { getContactByCriteria } from '../services/search.service';
import { FILTER_VARIANTS, FILTER_TITLES, FILTER_ID } from '../utils/surveyLiterals';

export const CompanyContactFilter = ({ setCompanyContactSelected, abortControllerRef }) => {
  const handleDeereContactSelection = (event) => {
    if (event) setCompanyContactSelected(event.value);
    else setCompanyContactSelected(null);
  };

  return (
    <LeftSearchMenuPiece>
      <LeftSearchMenuPiece.Item id={FILTER_ID.COMPANYCONTACT} title={FILTER_TITLES.COMPANYCONTACT}>
        <SelectFilter loadOptionsFunction={getContactByCriteria} onChange={handleDeereContactSelection} variant={FILTER_VARIANTS.COMPANYCONTACT} abortControllerRef={abortControllerRef} />
      </LeftSearchMenuPiece.Item>
    </LeftSearchMenuPiece>
  );
};
